<template>
    <div>
        <b-row sm="10">
            <b-col sm="4" class="col text-right"><label>รหัสสินค้า</label></b-col>
            <b-col sm="6"><input
                    class="form-control"
                    type="text"
                    v-model="form.sku"
                    disabled/></b-col>
        </b-row>
        <br />
        <b-row sm="10">
            <b-col sm="4" class="col text-right"><label>ชื่อสินค้า</label></b-col>
            <b-col sm="6"><input
                    class="form-control"
                    type="text"
                    v-model="form.name"
                    disabled/></b-col>
        </b-row>
        <br />
        <b-row sm="11">
            <b-col sm="4" class="col text-right"><label>จำนวนสินค้าคงเหลือ</label></b-col>
            <b-col sm="6"><input
                    class="form-control"
                    type="text"
                    v-model="form.quantity"
                    disabled/></b-col>
        </b-row>
        <br />
        <b-row sm="11">
            <b-col sm="4" class="col text-right"
                ><label>จำนวนที่นำเข้า</label></b-col>
            <b-col sm="6"><input
                    class="form-control"
                    type="number"
                    v-model="quantity"/></b-col>
        </b-row>
        <br />
        <b-row sm="10">
            <b-col sm="4" class="col text-right"
            ><label>เครื่องขึ้นรูป</label></b-col>
            <b-col sm="6">
                <multiselect
                    v-model="machine"
                    :options="optionMachine"
                    label="name"
                    track-by="name">
                </multiselect>
            </b-col>
        </b-row>
        <br />
        <b-row>
            <div class="col text-center">
                <button
                        :disabled="form.onSave"
                    type="button"
                    class="btn btn-success"
                    @click="onSubmitImport">
                    <icon name="save" style="width: 25px"></icon> บันทึก</button>&nbsp&nbsp
                <button type="button" class="btn btn-outline-secondary"
                        @click="goToImportProduct">
                    <icon name="times" style="width: 25px"></icon> ยกเลิก
                </button>
            </div>
        </b-row>
        <!--<pre class="alert alert-primary">{{ form }}</pre>-->
    </div>
</template>

<script>
import { mapState } from "vuex";
import Multiselect from "vue-multiselect";
export default {
    name: "import-data",
    components: { Multiselect },
    data() {
        return{
            quantity : "",
            machine : "",
        }
    },
    created() {
        this.$store.dispatch("Machine/get");
    },
    computed: {
        ...mapState({
            optionMachine: state => {
                return state.Machine.data;
            },
            user: state => {
                return state.Auth.user;
            },
            form : state =>{
                return state.Products.ProductForm;
            }
        })
    },

    methods: {
        onSubmitImport() {
            if(this.quantity < 1){
                alert('กรุณาใส่จำนวน');
            }
            else{
                let machine_id = "";
                if(this.machine){
                    machine_id = this.machine.id;
                }
                let data = {
                    product_id : this.form.id,
                    quantity: this.quantity,
                    machine_id: machine_id,
                    product_type_id: this.form.product_type.id,
                    user_id: this.user.id
                };
                this.form.onSave = true;
                this.$emit("submit", data);
                this.quantity = "";
                this.machine  = "";
            }
        },
        goToImportProduct(){
            this.$emit("submit", 1);
            this.quantity = "";
            this.machine  = "";
        }

    }
};
</script>

<style scoped></style>
